import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-new-header',
  templateUrl: './new-header.component.html',
  styleUrls: ['./new-header.component.scss'],
})
export class NewHeaderComponent implements OnInit {
  menuOpen = false;

  constructor(private router: Router) {}

  ngOnInit(): void {}

  toggleMenu() {
    this.menuOpen = !this.menuOpen;
  }

  goToWhyHuiospay() {
    this.router.navigate(['/why-huiospay']);
  }

  goToDevelopers() {
    this.router.navigate(['/developers']);
  }

  goToSupport() {
    this.router.navigate(['/support']);
  }
}
